import Vue from 'vue';
import api from "../../util/api";

export const DOCUMENTS_SET = 'DOCUMENTS_SET';
export const DOCUMENTS_LOAD = 'DOCUMENTS_LOAD';

const capitalize = (s) => {
    if (typeof s !== 'string') {
        return ''
    }

    return s.charAt(0).toUpperCase() + s.slice(1)
}

export default {
    state: {
        map: {},

        listAll: [],
        listSearch: [],
        listContext: [],
    },

    mutations: {
        [DOCUMENTS_SET](state, {mode, list}) {
            list.forEach(item => {
                Vue.set(state.map, item.id, item);
            })

            Vue.set(state, `list${capitalize(mode)}`, list.map(i => i.id));
        }
    },

    getters: {
        documents: state => mode => state[`list${capitalize(mode)}`],
        documentsByCategory: state => category => state.listAll.map(i => state.map[i]).filter(i => i.categoryId === category).map(i => i.id),
        documentById: state => id => state.map[id],
    },

    actions: {
        async [DOCUMENTS_LOAD]({commit}, {mode = 'context', filter}) {

            console.log('Loading documents', filter);

            const {data} = await api.documents(filter);

            commit(DOCUMENTS_SET, {mode, list: data.data});
        }
    }
}